import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { CheckboxComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TraspasoClienteService } from 'src/app/services/traspaso-cliente.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-traspaso-masivo-modal-marcado-masivo',
  templateUrl: './modal-marcado-masivo.component.html',
  styleUrls: ['../traspaso-masivo-cliente.component.scss'],
  providers: [SecurityService]
})
export class ModalMarcadoMasivoComponent implements OnInit {

  // public readonly TIPO_ZONAS = 1
  public readonly TIPO_RUTAS = 1 // ANTES ESTABA 2
  public readonly TIPO_TERRITORIOS = 2 //2 DE TERRITORIOS - ANTES ESTABA 3
  public readonly TIPO_CLIENTE = 3 // 3 TIPO DE CLIENTES - ANTES ESTABA 4

  // Modales
  @ViewChild('marcacionMasiva', { static: true }) modalMarcadoMasivo: ModalDirective;
  @ViewChild(CheckboxComponent, {static:true}) checkboxAll: CheckboxComponent;
  @Input() enviarClientesSelecc: Array<any> = []; //Clientes recibidos cuando son seleccionados en vista principal
  @Output() RespforMMasivo = new EventEmitter<any>(); //actualizar grilla principal

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  loading: boolean = false
  listaMovimientos: Array<any> = null
  listaMovimientosAll: Array<any> = null
  areSelected: boolean = false
  selected: any[]
  paginationContext: PaginationContext = new PaginationContext()


  // Utils
  private log: any
  valueInput: any;
  element: HTMLElement;
  clientesSeleccionados: any;
  tipoMarcacion: number;
  seleccionForTraspasoMasivo: Array<any> = [];
  checkBoxSelectAll: HTMLInputElement;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private traspasoClienteService: TraspasoClienteService
  ) {
    this.log = this.clog.log('TRAPASO-MASIVO-CLIENTES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10
    this.createForms();
    this.buscar(this.TIPO_RUTAS, 1);
    this.formChangesSubscriptions();


  }

  private createForms() {
    this.formHeader = this.fb.group({
      marcar: [null, []],
      tipo: [this.TIPO_RUTAS, []]
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("tipo").valueChanges
      .subscribe((tipo) => {
        this.log('tipo', tipo, this.formHeader.get('tipo').value)
        this.clearData()
        this.buscar(tipo, 1)
      })
  }

  show() {
    this.modalMarcadoMasivo.show()
  }

  load(){
    this.clientesSeleccionados = this.enviarClientesSelecc.length
    this.show()
  }

  clearData() {
    this.areSelected = false
    this.selected = []
    this.loading = false
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    this.paginationContext.CurrentPage = 1
    // this.formValidatorsService.reset(this.formHeader)
  }

  buscar(tipo_marcacion: number, pageNumber: number = 1) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber

    this.loading = true
    this.listaMovimientos = []
    this.listaMovimientosAll = []

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        tipo_marcacion
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }

    //* MODIFICA EL CHECKBOX DE MARCAR/DESMARCAR TODO CUANDO SE CAMBIA EL TIPO DE MARCACION, SIEMPRE Y CUANDO SE SELECCIONEN TODOS LOS CODIGOS
    this.checkBoxSelectAll = document.getElementById('checkBoxAllSelect') as HTMLInputElement;
    this.checkBoxSelectAll.checked = false;

    //* ENVIAR TIPO DE MARCACION A VARIABLE
    this.tipoMarcacion = tipo_marcacion;
    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.traspasoClienteService.obtenerMarcacionMasiva(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach(p => {
        p.rutFormato = this.rutService.AgregarDV(p.rut)
      })

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.additionalInfo.index = index
        mov.additionalInfo.checked = false

        mov.envio_rec = true // TODO: Remove this line. It exists is only for dev purposes
      });

      this.loading = false
      this.showPage(this.paginationContext.CurrentPage)
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }


  //* MARCAR/DESMARCAR TODO
  setValue(inputValue) {

      this.listaMovimientosAll.filter(p => p.envio_rec).forEach(mov => { mov.additionalInfo.checked = inputValue })
      this.listaMovimientos.filter(p => p.envio_rec).forEach(mov => { mov.additionalInfo.checked = inputValue })

    // retorno todos los elementos checkeados para enviarlos a la listaTerritorio || listaRuta || lista TipoCliente
    const dato = this.listaMovimientosAll.map(cliente => {
      cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
      // cliente.checked = false
      this.removeElementTypename(cliente)
      const params = {
        checked : cliente.additionalInfo.checked,
        codigo_marcacion: cliente.codigo_marcacion
      }

      return params
    }).filter(x=>x.checked == true);

    this.seleccionForTraspasoMasivo = dato.map(lista => {
      const params = {
        codigo_marcacion: lista.codigo_marcacion
      }
      return params.codigo_marcacion
     });

     console.log(this.seleccionForTraspasoMasivo);

      this.handleAreSelected()
  }

  checkDetalle({ index }, { checked }) {
    const _indexAll = this.listaMovimientosAll.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientosAll[_indexAll].additionalInfo.checked = checked

    const _indexPage = this.listaMovimientos.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientos[_indexPage].additionalInfo.checked = checked


    // retorno todos los elementos checkeados para enviarlos a la listaTerritorio || listaRuta || lista TipoCliente
    const dato = this.listaMovimientosAll.map(cliente => {
      cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
      // cliente.checked = false
      this.removeElementTypename(cliente)
      const params = {
        checked : cliente.additionalInfo.checked,
        codigo_marcacion: cliente.codigo_marcacion
      }

      return params
    }).filter(x=>x.checked == true);

     this.seleccionForTraspasoMasivo = dato.map(lista => {
      const params = {
        codigo_marcacion: lista.codigo_marcacion
      }
      return params.codigo_marcacion
     })

    this.handleAreSelected()
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }

  handleAreSelected() {
    if (!this.listaMovimientosAll || this.listaMovimientosAll.length == 0)
      this.areSelected = false
    this.selected = this.listaMovimientosAll.filter(mov => mov.additionalInfo.checked)
    this.areSelected = this.selected.length > 0
  }

  marcacionMasivaClientes(){

    const inputParams = {
      tipo_marcacion: this.tipoMarcacion,
      entidad: {
        listaRuta: this.TIPO_RUTAS === this.tipoMarcacion ? this.seleccionForTraspasoMasivo : [] ,
        listaTerritorio: this.TIPO_TERRITORIOS === this.tipoMarcacion ? this.seleccionForTraspasoMasivo : [],
        listaTipoCliente: this.TIPO_CLIENTE === this.tipoMarcacion ? this.seleccionForTraspasoMasivo : []
      },
      listaCliente: this.enviarClientesSelecc
    }

    this.log('MARCACION MASIVA CLIENTES', JSON.stringify(inputParams))


    this.traspasoClienteService.obtenerMarcacionSegunClientes(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.RespforMMasivo.emit();
      this.modalMarcadoMasivo.hide()
    })

  }

}
